import React, { useState, useRef, useEffect, useCallback } from "react";
import ListPageHeader from "../../utilities/ListPageHeader";
import AgGridTable from "../../utilities/AgGridTable";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { confirmAlert } from "react-confirm-alert";
import { Checkbox, IconButton, Switch, Tooltip } from "@mui/material";

import ExpenseClaimFilter from "./ExpenseClaimFilter";
import ExpenseClaimForm from "./ExpenseClaimForm";

import { useNavigate } from "react-router-dom";
import jwtDecode from "jwt-decode";

import "./expenseClaim.css";
import { toast } from "react-toastify";

const token =
  localStorage.getItem("token") && jwtDecode(localStorage.getItem("token"));

const expenseListURL = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.expenseClaimList}`;
const expenseClaimUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.expenseClaim}`;

const ApprovedIconComponent=(props)=> {
  let bool = props?.data?.isApproved
  return <Switch size="small" defaultChecked={bool} disabled />
}
const FinancedIconComponent=(props)=> {
  let bool = props?.data?.isFinanced
  return <Switch size="small" defaultChecked={bool} disabled />
}

const ExpenseClaim = () => {
  const [open, setOpen] = useState(false);
  const [editRowOpen, setEditRowOpen] = useState(false);
  const [viewRowOpen, setViewRowOpen] = useState(false);
  const [viewRowMainOpen, setViewRowMainOpen] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [addRow, setAddRow] = useState([]);
  const [editRow, setEditRow] = useState([]);
  const [viewRow, setViewRow] = useState([]);
  const [addRowData, setAddRowData] = useState([]);
  const [edit, setEdit] = useState(false);
  const [showPaginationDropdown, setShowPaginationDropdown] = useState(false);
  const [postDisable, setPostDisable] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);

  const gridRef = useRef();
  const perPage = 10;
  const [gridApi, setGridApi] = useState(null);
  const [columnDefs, setColumnDefs] = useState([
    {
      field: "docNo",
      enableRowGroup: true,
      headerName: "Doc Number",
      filter: "agNumberColumnFilter",
      maxWidth: 120,
    },
    { field: "docDate", enableRowGroup: true, headerName: "Date", maxWidth: 120, },
    { field: "employeeId", enableRowGroup: true, headerName: "Employee Id", maxWidth: 120, },
    {
      field: "employeeName",
      headerName: "Employee Name",
    },
    {
      field: "remark",
      headerName: "Remarks",
    },
    {
      field: "isApproved",
      headerName: "Approved?",
      cellRenderer: ApprovedIconComponent,
      editable: false,
      maxWidth: 120,
    },
    {
      field: "isFinanced",
      headerName: "Financed?",
      cellRenderer: FinancedIconComponent,
      editable: false,
      maxWidth: 120,
    },
  ]);
  const [error, setError] = useState();
  const [successMsg, setSuccessMsg] = useState();
  const [snackState, setSnackState] = useState(false);
  const navigate = useNavigate();

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const loadData = async () => {
    if (
      token?.scope?.includes("ROLE_FINANCE") ||
      token?.scope?.includes("ROLE_FINMGR")
    ) {
      try {
        const list = await OAuthService.getList(expenseListURL);
        let expenseClaimList = list.data._embedded.expenses;
        // console.log(expenseClaimList);
        setRowData(expenseClaimList);
      } catch (error) {
        setError(error.message);
      }
    } else {
      const token =
        localStorage.getItem("token") &&
        jwtDecode(localStorage.getItem("token"));
      const url = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.employees}`;
      const email = token?.email;

      const emp = await OAuthService.getList(
        url + `/search/findEmployeeByEmail?email=${email}`
      );

      try {
        const list = await OAuthService.getList(
          `${expenseListURL}/search/findByEmployeeIdOrderByCreatedAtDesc?employeeId=${emp?.data?.employeeId}`
        );
        let expenseClaimList = list.data._embedded.expenses;
        setRowData(expenseClaimList);
      } catch (error) {
        setError(error.message);
      }
    }
  };

  useEffect(() => {
    if (gridApi) {
      loadData();
    }
  }, [gridApi]);

  const handleAddDialogOpen = (event) => {
    setOpen(true);
    setAddRow(event);
  };
  const handleViewRowDialogOpen = (event) => {
    setViewRowOpen(true);
    setViewRow(event);
  };
  const handleEditRowDialogOpen = (event) => {
    event?.data?.isFinanced
      ? setEditRowOpen(true)
      : toast.error("Expense is not financed");
    setEditRow(event.data);
  };

  const handleAddButton = () => {
    // setViewRowMainOpen(true);
    navigate("/expense-claim/add");
  };

  const handleClose = () => {
    setOpen(false);
    setEditRowOpen(false);
    setViewRowOpen(false);
    setViewRowMainOpen(false);
  };

  const handlePTF = async () => {
    // const array = rowData.filter((item) => item.isApproved === true);
    // console.log(array);
    const addUrl = `${process.env.REACT_APP_HR_API_KEY_URL}api/expenseClaim/postToFinance/${selectedRows[0].id}`;
    await OAuthService.getList(addUrl)
      .then((respData) => {
        console.log(respData);
        navigate(`/editVoucher/${respData?.data}`);
      })
      .catch((error) => setError(error.message));
  };

  const getContextMenuItems = (event) => {
    var result = [
      // {
      //   name: "Add",
      //   icon: '<span><i class="material-icons style="font-size: 18px">perm_identity</i></span>',
      //   action: () => {
      //     handleAddDialogOpen(event);
      //   },
      // },
      {
        name: "View",
        icon: '<span><i class="material-icons" style="font-size: 18px">visibility</i></span>',
        action: (props) => {
          const data = event?.node?.data;
          navigate(
            `/expense-claim/add?id=${data?.id}&doc=${data?.docNo}&view=true&approved=${data?.isFinanced}`
          );
        },
      },
      {
        name: "Edit",
        icon: '<span><i class="material-icons" style="font-size: 18px">edit</i></span>',
        action: (props) => {
          const data = event?.node?.data;
          navigate(
            `/expense-claim/add?id=${data?.id}&doc=${data?.docNo}&approved=${data?.isFinanced}`
          );
        },
      },
      {
        name: "Delete",
        icon: '<span><i class="material-icons" style="font-size: 18px">delete</i></span>',
        action: () => {
          onDelete(event);
        },
      },
    ];
    return result;
  };

  const handleEdit = async (
    event,
    values,
    period,
    selectedYear,
    firstDay,
    lastDay,
    selectedCompany,
    companyName
  ) => {
    const id = event?.node?.data?._links?.self?.href.split("/").pop();
    const editRow = {
      id: id,
      companyCode: selectedCompany.value,
      companyName: companyName,
      period: period.label,
      year: selectedYear.value,
      startDate: firstDay,
      endDate: lastDay,
      postingAllowed: values.postingAllowed,
      availableInventory: values.availableInventory,
      pricingAllowed: values.pricingAllowed,
      resetAllowed: values.resetAllowed,
    };
    try {
      if (id) {
        await OAuthService.updateData(url, id, editRow);
        loadData();
        setSuccessMsg("Data Updated Successfully");
        setSnackState(true);
      }
    } catch (error) {
      setError(error.message);
      return;
    }
  };

  const onDelete = useCallback(
    (event) => {
      const selectedRow = [event.node.data];

      confirmAlert({
        title: "Confirm to delete",
        message: "Are you sure to delete.",
        buttons: [
          {
            label: "Yes",
            onClick: () => {
              rowData.splice(event.node.rowIndex, 1);
              gridRef?.current?.api.applyTransaction({ remove: selectedRow });
              selectedRow.map(async (row) => {
                const dataUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.expenseClaimList}`;
                await OAuthService.deleteData(dataUrl, row.id);
                setSuccessMsg("Data deleted Successfully");
                setSnackState(true);
              });
            },
          },
          {
            label: "No",
            onClick: () => {},
          },
        ],
      });
    },
    [gridRef, rowData]
  );

  const handleAddNewRow = async (
    values,
    period,
    selectedYear,
    firstDay,
    lastDay,
    selectedCompany,
    companyName
  ) => {
    const payload = {
      companyCode: selectedCompany.value,
      companyName: companyName,
      period: period.label,
      year: selectedYear.value,
      startDate: firstDay,
      endDate: lastDay,
      postingAllowed: values.postingAllowed,
      availableInventory: values.availableInventory,
      pricingAllowed: values.pricingAllowed,
      resetAllowed: values.resetAllowed,
    };
    await OAuthService.addData(url, payload);
    loadData();
    setSuccessMsg("Data saved Successfully");
    setSnackState(true);
  };

  const handleClearYear = useCallback(() => {
    var countryFilterComponent = gridRef.current.api.getFilterInstance("year");
    countryFilterComponent.setModel(null);
    gridRef.current.api.onFilterChanged();
  }, []);

  const handleSearch = useCallback((value) => {
    console.log('value', value)
    // const addUrl = `${process.env.REACT_APP_HR_API_KEY_URL}api/expenseClaim/search`;
    OAuthService.addData(`${expenseClaimUrl}/filterExpenseClaimData`, value)
      .then((resp) => {
        if (resp.data.length !== 0) {
          setRowData(resp.data);
        }
      })
      .catch((error) => setError(error.message));
  }, []);

  const onBtExport = useCallback(() => {
    const params = {
      fileName: "ExpenseClaim.xlsx",
      sheetName: "Expense Claim",
    };
    gridRef.current.api.exportDataAsExcel(params);
  }, []);

  const onRowDoubleClicked = (params) => {
    handleEditRowDialogOpen(params);
  };

  const onSelectionChanged = (params) => {
    setSelectedRows(params.api.getSelectedRows());
  };

  useEffect(() => {
    if (selectedRows.length > 0 && selectedRows.length < 2) {
      if (selectedRows[0].isApproved === true) {
        setPostDisable(false);
      } else {
        setPostDisable(true);
      }
      // setPostDisable(false);
    } else {
      setPostDisable(true);
    }
  }, [selectedRows]);

  const handleConfig = () => {
    navigate("/expense-claim/config");
  };

  return (
    <>
      <ListPageHeader
        componentName="Expense Claim"
        onBtExport={onBtExport}
        handleAddButton={handleAddButton}
        handleConfig={
          token?.scope?.includes("ROLE_FINANCE") ||
          token?.scope?.includes("ROLE_FINMGR")
            ? handleConfig
            : null
        }
        pageName="Expense Claim"
        //headerInputFields={exchangeRateFilter()}
        error={error}
        successMsg={successMsg}
        gridRef={gridRef}
        // showPaginationDropdown={showPaginationDropdown}
      />
      <ExpenseClaimFilter
        handleMainRowDialogOpen={handleAddButton}
        handleClearYear={handleClearYear}
        handlePTF={handlePTF}
        handleSearch={handleSearch}
        postDisable={postDisable}
      />
      <div className="h-full pr-24 pl-24 w-full">
        <AgGridTable
          columnDefs={columnDefs}
          onGridReady={onGridReady}
          gridRef={gridRef}
          rowData={rowData}
          getContextMenuItems={getContextMenuItems}
          editable={false}
          pagination={false}
          onSelectionChanged={onSelectionChanged}
          onRowDoubleClicked={onRowDoubleClicked}
        />
      </div>
      <ExpenseClaimForm
        rowData={rowData}
        open={open}
        editRowOpen={editRowOpen}
        viewRowOpen={viewRowOpen}
        viewRowMainOpen={viewRowMainOpen}
        addRow={addRow}
        editRow={editRow}
        viewRow={viewRow}
        handleEdit={handleEdit}
        handleClose={handleClose}
        handleAddNewRow={handleAddNewRow}
      />
    </>
  );
};

export default ExpenseClaim;
